import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e74bc16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column",
  style: {"min-height":"400px"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-5 align-items-center\" data-v-1e74bc16><div data-v-1e74bc16><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1e74bc16><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-1e74bc16></rect><path d=\"M26.8488 25.625C25.8569 25.625 24.9451 26.0068 24.2254 26.6453L19.7286 23.5176C19.8618 22.8473 19.8618 22.1527 19.7286 21.4823L24.2254 18.3547C24.9451 18.9932 25.8569 19.375 26.8488 19.375C29.1752 19.375 31.0611 17.2763 31.0611 14.6875C31.0611 12.0987 29.1752 10 26.8488 10C24.5225 10 22.6366 12.0987 22.6366 14.6875C22.6366 15.037 22.6713 15.3774 22.7365 15.7051L18.2397 18.8328C17.52 18.1943 16.6082 17.8125 15.6163 17.8125C13.2899 17.8125 11.4041 19.9112 11.4041 22.5C11.4041 25.0888 13.2899 27.1875 15.6163 27.1875C16.6082 27.1875 17.52 26.8057 18.2397 26.1672L22.7365 29.2949C22.67 29.629 22.6365 29.9703 22.6366 30.3125C22.6366 32.9013 24.5225 35 26.8488 35C29.1752 35 31.0611 32.9013 31.0611 30.3125C31.0611 27.7237 29.1752 25.625 26.8488 25.625Z\" fill=\"#203972\" data-v-1e74bc16></path></svg></div><div data-v-1e74bc16><p class=\"m-0 subtitulo cor_texto_1\" data-v-1e74bc16>Dados da integração</p></div></div><div class=\"px-5\" data-v-1e74bc16><hr class=\"text-muted m-0\" data-v-1e74bc16></div>", 2)
const _hoisted_4 = {
  key: 0,
  class: "p-5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-3 fw-bold" }, "Geral", -1))
const _hoisted_6 = {
  class: "row p-4",
  style: {"width":"100%"}
}
const _hoisted_7 = {
  class: "col-12 d-flex flex-column p-0 gap-3",
  id: "ulGeral"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fs-3 fw-bold" }
const _hoisted_11 = { style: {"background-color":"rgb(234, 234, 234)","padding":"1rem"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "fs-3 subtitulo pt-4",
  style: {"border-top":"0.5px solid gray"}
}, "Credenciais", -1))
const _hoisted_13 = {
  action: "",
  class: "row p-4",
  style: {"width":"100%"}
}
const _hoisted_14 = { class: "col-12 d-flex flex-row p-0 gap-3" }
const _hoisted_15 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center box"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-4 flex-column mt-4 mb-4 justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "250",
    height: "175",
    viewBox: "0 0 250 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M166.295 87.5089C159.694 87.5089 153.483 83.9935 150.124 78.3689L125.009 36.7309L99.9321 78.3689C96.5339 84.0326 90.3233 87.548 83.7222 87.548C81.9645 87.548 80.2068 87.3136 78.5272 86.8058L25.015 71.4943V141.021C25.015 146.763 28.921 151.763 34.4675 153.13L118.915 174.261C122.899 175.238 127.079 175.238 131.024 174.261L215.55 153.13C221.096 151.724 225.002 146.724 225.002 141.021V71.4943L171.49 86.7668C169.811 87.2746 168.053 87.5089 166.295 87.5089ZM249.337 43.6836L229.221 3.52984C228.01 1.10812 225.393 -0.298043 222.698 0.0534977L125.009 12.5137L160.827 71.924C162.311 74.3848 165.28 75.5565 168.053 74.7754L245.353 52.7064C249.22 51.5737 251.094 47.2771 249.337 43.6836ZM20.7965 3.52984L0.680553 43.6836C-1.11621 47.2771 0.797733 51.5737 4.62562 52.6674L81.9254 74.7363C84.6987 75.5175 87.6673 74.3457 89.1515 71.8849L125.009 12.5137L27.2804 0.0534977C24.5853 -0.258983 22.0073 1.10812 20.7965 3.52984Z",
      fill: "#E8E8E8"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Loja não possui dados de integração")
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.exibirIntegracao && _ctx.dadosExtraRef.dadosExtras.geral)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keysObjGeral, (chave, key) => {
                return (_openBlock(), _createElementBlock("li", { key: key }, [
                  (!Array.isArray(_ctx.dadosExtraRef.dadosExtras.geral[chave]))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(chave), 1),
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.dadosExtraRef.dadosExtras.geral[chave],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.dadosExtraRef.dadosExtras.geral[chave]) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", _hoisted_10, _toDisplayString(chave), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dadosExtraRef.dadosExtras.geral[chave], (item, key) => {
                            return (_openBlock(), _createElementBlock("li", { key: key }, [
                              _createElementVNode("span", null, _toDisplayString(item.nome), 1),
                              _createVNode(_component_el_input, {
                                modelValue: item.status,
                                "onUpdate:modelValue": ($event: any) => ((item.status) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          }), 128))
                        ])
                      ]))
                ]))
              }), 128))
            ])
          ]),
          _hoisted_12,
          _createElementVNode("form", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keysObjCredencias, (chave, key) => {
                return (_openBlock(), _createElementBlock("li", { key: key }, [
                  _createElementVNode("span", null, _toDisplayString(chave), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.dadosExtraRef.dadosExtras.credenciais[chave],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dadosExtraRef.dadosExtras.credenciais[chave]) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
  ]))
}